import { PaymentFlowName, PaymentFlowStep } from '../types/payment';

export const paymentFlowSteps: Partial<Record<PaymentFlowName, string[]>> = {
  login_trial_expired_paywall: [
    PaymentFlowStep.loginCompleted,
    PaymentFlowStep.subscriptionExpiredDetected,
    PaymentFlowStep.paymentModalViewed,
    PaymentFlowStep.payClicked,
    PaymentFlowStep.recurrenceModal,
    PaymentFlowStep.recurrenceSelected,
    PaymentFlowStep.checkoutViewed,
    PaymentFlowStep.paymentSubmitted,
    PaymentFlowStep.paymentFailed,
    PaymentFlowStep.paymentSuccess,
  ],
  library_theme_private_content: [
    PaymentFlowStep.subscriptionOnlyContentViewed,
    PaymentFlowStep.paymentModalViewed,
    PaymentFlowStep.payClicked,
    PaymentFlowStep.recurrenceModal,
    PaymentFlowStep.recurrenceSelected,
    PaymentFlowStep.checkoutViewed,
    PaymentFlowStep.paymentSubmitted,
    PaymentFlowStep.paymentFailed,
    PaymentFlowStep.paymentSuccess,
  ],
  login_subscription_expired_paywall: [
    PaymentFlowStep.loginCompleted,
    PaymentFlowStep.subscriptionExpiredDetected,
    PaymentFlowStep.paymentModalViewed,
    PaymentFlowStep.payClicked,
    PaymentFlowStep.recurrenceModal,
    PaymentFlowStep.recurrenceSelected,
    PaymentFlowStep.checkoutViewed,
    PaymentFlowStep.paymentSubmitted,
    PaymentFlowStep.paymentFailed,
    PaymentFlowStep.paymentSuccess,
  ],
};
